export enum AtomSwitcherSizeEnum {
  NORMAL = "normal",
  MINI = "mini",
}
